import { legacyColors } from '~/legacyTheme';

export const useSxStyles = () => {
  return {
    actionScopes: {
      backgroundColor: 'initial',
    },
    flex: {
      backgroundColor: '#fafafa',
      display: 'flex',
      marginTop: '2px',
    },
    expandableIcon: {
      margin: 0,
      color: 'initial',
      display: 'flex',
      padding: '4px',
      '& svg': {
        padding: '4px',
      },
    },
    li: {
      padding: 0,
      border: 'none',
      borderRadius: 0,
      outline: 'none',
      fontWeight: 'normal',
      color: '#454545',

      '&:hover': {
        color: legacyColors.blue,
        background: '#cde6f6',
      },
    },
    liOpened: {
      color: legacyColors.blue,
      background: '#cde6f6',
    },
  };
};
